import { t } from "../../utils/i18n";

export const greetUser = (name) => {
  const hour = new Date().getHours();
  if (hour < 12) return t("dashboard.greeting.morning");
  if (hour < 18) return t("dashboard.greeting.afternoon");
  return t("dashboard.greeting.evening");
};

export const cryptoBalance = (
  type,
  balances,
  preferredCrypto,
  alt_currency
) => {
  let preferredAsset = balances?.find(
    (balance) => balance.crypto === preferredCrypto
  );
  if (preferredAsset) {
    if (type === "crypto_balance") {
      return preferredAsset.crypto_balance;
    } else if (type === "alt_balance") {
      return preferredAsset.alt_balance;
    } else if (type === "usd_balance") {
      return preferredAsset.usd_balance;
    }
  }
  if (type === "crypto_balance") {
    return "$ 0.00";
  } else {
    return `${alt_currency} 0.00`;
  }
};
